import { ButtonHTMLAttributes } from "react";

interface Props extends ButtonHTMLAttributes<HTMLButtonElement> {
  /** When true the button is disabled and shows a spinner next to its label. */
  loading?: boolean;
}

/**
 * Submit button with a built-in loading state. While `loading` is true the
 * button is disabled and a spinner appears beside the label, so the user gets
 * immediate feedback that their submission is being processed.
 */
export default function SubmitButton({
  loading = false,
  disabled,
  children,
  className = "",
  ...props
}: Props) {
  return (
    <button
      {...props}
      type={props.type ?? "submit"}
      disabled={loading || disabled}
      aria-busy={loading}
      className={`disabled:opacity-60 disabled:cursor-not-allowed ${className}`}
    >
      <span className="inline-flex items-center justify-center gap-2">
        {loading && (
          <svg
            className="w-4 h-4 animate-spin shrink-0"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden="true"
          >
            <circle
              className="opacity-25"
              cx="12"
              cy="12"
              r="10"
              stroke="currentColor"
              strokeWidth="4"
            />
            <path
              className="opacity-75"
              fill="currentColor"
              d="M4 12a8 8 0 0 1 8-8V0C5.373 0 0 5.373 0 12h4z"
            />
          </svg>
        )}
        {children}
      </span>
    </button>
  );
}
